import { AuthModal, View } from '@fairygodboss/ui';
import { useEffect, useState } from 'react';

import { UseModalState } from '../../context/ModalContext';

export const ModalTrigger = ({ ...props }) => {
    const {
        modalOpen,
        setModalOpen,
        auth0,
        timer,
        loginMetrics,
        leadInLogin,
        leadInPopup,
        setLayoutType,
        isPayWall,
        regWall,
        layoutType,
    } = UseModalState();
    const [loginPath, setLoginPath] = useState('');
    const [mounted, setMounted] = useState(false);
    const closeModal = () => {
        setModalOpen(null);
        setLayoutType(String('none'));
    };
    useEffect(() => {
        setLoginPath(window.location.pathname);
        setMounted(true);
    }, []);
    return (
        <View>
            <style jsx global>
                {`
                    .modalContainer {
                        display: ${modalOpen ? 'block!important' : 'none'};
                    }
                    .component-Login-LoginLayoutComponent.wide {
                        width: 95% !important;
                        padding: 20px 10px !important;
                    }

                    @media (max-width: 905px) and (orientation: portrait) {
                        .content {
                            width: 340px !important;
                            overflow-y: hidden !important;
                            background-color: transparent !important;
                        }
                        .component-Login-LoginLayoutComponent.wide {
                            padding: 20px 10px !important;
                        }
                    }
                    @media (max-width: 905px) and (orientation: landscape) {
                        .content {
                            width: 340px !important;
                            background-color: transparent !important;
                        }

                        .component-Login-LoginLayoutComponent.wide {
                            padding: 20px 10px !important;
                        }
                    }
                    @media (min-width: 905px) and (orientation: landscape) {
                        .component-Login-LoginLayoutComponent.wide {
                            width: 95% !important;
                            padding: 20px 10px !important;
                        }
                    }
                `}
            </style>
            {mounted && modalOpen && (
                <AuthModal
                    className="modalContainer"
                    isOpen={modalOpen}
                    timer={timer}
                    onClose={closeModal}
                    auth0={auth0}
                    loginRedirectPath={loginPath}
                    loginMetrics={loginMetrics}
                    displayMode="popup"
                    setLayoutType={setLayoutType}
                    leadInLogin={leadInLogin}
                    leadInPopup={leadInPopup}
                    isPayWall={isPayWall}
                    regWallInfo={regWall}
                    layoutType={layoutType}
                    {...props}
                />
            )}
        </View>
    );
};
